/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import QS from 'qs'
import { Toast } from 'vant'
import { ToLogin } from '../utils/utils'
import Cookies from 'js-cookie'

axios.defaults.baseURL =
  process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BaseAPI : '/api'
// 请求超时时间
axios.defaults.timeout = 10000

// post请求头
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = window.localStorage.getItem('token')
    const token = Cookies.get('token')
    // const token =
    //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJQYW5lbCIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL3NpZCI6IjQ0MzU2NTk4NjIzNzAwMDEiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2V4cGlyYXRpb24iOiI2LzEzLzIwIDk6NTY6NDQgQU0iLCJuYmYiOjE1OTE5MjcwMDQsImV4cCI6MTU5MTk2MzAwNCwiaXNzIjoicGZnLml0IiwiYXVkIjoiUGZnIn0.mS_bgdW87j1m2TtYlmvAoJN2NakG0ddafeQp81fB9uc'
    token && (config.headers.Authorization = `Bearer ${token}`)
    return config
  },
  (error) => {
    return Promise.error(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    if (error.response.status) {
      switch (error.response.status) {
        case 401:
          // token失效 重新授权
          console.log(' token失效')
          ToLogin()
          break
        case 500:
          // token失效 重新授权
          Toast({
            message: '服务端出错',
            duration: 1500,
            forbidClick: true,
          })
          break
        // 其他错误，直接抛出错误提示
        default:
          console.log(error)
          Toast({
            message: error.response.msg,
            duration: 1500,
            forbidClick: true,
          })
      }
      return Promise.reject(error.response)
    }
  }
)
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function GET(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        if (res.data.code == 200) {
          resolve(res.data.result)
        } else {
          Toast({
            message: res.data.msg,
            duration: 1500,
            forbidClick: true,
          })
          console.error(`${baseUrl}请求报错`, res.data)
          reject(res.data)
        }
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}

export function POSTJSON(url, data, headers) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        headers: Object.assign(
          {
            'Content-Type': 'application/json',
          },
          headers
        ),
      })
      .then((res) => {
        if (res.data.code == 200) {
          resolve(res.data.result)
        } else {
          Toast({
            message: res.data.msg,
            duration: 1500,
            forbidClick: true,
          })
          console.error(`${baseUrl}请求报错`, res.data)
          reject(res.data)
        }
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}
